module.exports = __webpack_public_path__ + "static/img/14.fd4ae56f.png";